/* No Worries Bru — theme interactions
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.NWB_CURRENCY || 'GBP',
    });

  /* ------------------------------------------------------------------
     Cart drawer + AJAX cart
     ------------------------------------------------------------------ */
  const Cart = {
    drawer: null,

    init() {
      this.drawer = document.getElementById('CartDrawer');

      document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-cart-toggle]');
        if (openBtn) { e.preventDefault(); this.open(); }

        const closeBtn = e.target.closest('[data-cart-close]');
        if (closeBtn) { e.preventDefault(); this.close(); }

        const removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) { e.preventDefault(); this.changeLine(removeBtn.dataset.cartRemove, 0); }
      });

      // Persist delivery note from the drawer
      document.addEventListener('change', (e) => {
        const noteEl = e.target.closest('[data-cart-note]');
        if (noteEl) this.saveNote(noteEl.value);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
        form.addEventListener('submit', (e) => this.addFromForm(e, form));
      });
    },

    async addFromForm(e, form) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('add failed');
        await this.refresh();
        this.open();
      } catch (err) {
        form.submit();
      } finally {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      }
    },

    async changeLine(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      this.render(cart);
    },

    async refresh() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      this.render(cart);
    },

    saveNote(note) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note }),
      });
    },

    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      const itemsEl = this.drawer && this.drawer.querySelector('[data-cart-items]');
      const footerEl = this.drawer && this.drawer.querySelector('[data-cart-footer]');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn--secondary" href="/collections/all">Start shopping</a></div>';
        if (footerEl) footerEl.hidden = true;
        return;
      }

      if (footerEl) footerEl.hidden = false;
      itemsEl.innerHTML = cart.items.map((item) => `
        <div class="line-item">
          <a class="line-item__img" href="${item.url}">
            ${item.image ? `<img src="${item.image.replace(/(\.[^.]+)$/, '_160x$1')}" alt="${item.product_title}" width="72" height="72">` : ''}
          </a>
          <div>
            <a class="line-item__title" href="${item.url}">${item.product_title}</a>
            ${item.variant_title ? `<div class="line-item__variant">${item.variant_title}</div>` : ''}
            <div class="line-item__variant">Qty ${item.quantity}</div>
            <button class="line-item__remove" data-cart-remove="${item.key}">Remove</button>
          </div>
          <div class="line-item__price">${money(item.final_line_price)}</div>
        </div>`).join('');

      const subtotalEl = this.drawer.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    },

    open() {
      if (this.drawer) { this.drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    },
    close() {
      if (this.drawer) { this.drawer.removeAttribute('open'); document.body.style.overflow = ''; }
      const mn = document.getElementById('MobileNav');
      if (mn) mn.removeAttribute('open');
    },
  };

  /* ------------------------------------------------------------------
     Generic drawers (filter & sort, etc.)
     ------------------------------------------------------------------ */
  function initDrawers() {
    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-drawer-open]');
      if (openBtn) {
        e.preventDefault();
        const d = document.getElementById(openBtn.dataset.drawerOpen);
        if (d) { d.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
      }
      const dismiss = e.target.closest('[data-drawer-dismiss]');
      if (dismiss) {
        e.preventDefault();
        const d = dismiss.closest('.drawer');
        if (d) { d.removeAttribute('open'); document.body.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.drawer[open]').forEach((d) => d.removeAttribute('open'));
        document.body.style.overflow = '';
      }
    });
  }

  /* ------------------------------------------------------------------
     Mobile nav
     ------------------------------------------------------------------ */
  function initMobileNav() {
    const nav = document.getElementById('MobileNav');
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-mobile-toggle]')) { e.preventDefault(); nav && nav.toggleAttribute('open'); document.body.style.overflow = nav.hasAttribute('open') ? 'hidden' : ''; }
      if (e.target.closest('[data-mobile-close]')) { e.preventDefault(); nav && nav.removeAttribute('open'); document.body.style.overflow = ''; }
    });
  }

  /* ------------------------------------------------------------------
     Product gallery thumbnails
     ------------------------------------------------------------------ */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (main) main.src = thumb.dataset.full;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.setAttribute('aria-current', 'false'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */
  function initQuantity() {
    document.querySelectorAll('[data-quantity]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = btn.dataset.dir === 'up' ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Carousel (Our Favourites)
     ------------------------------------------------------------------ */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      const step = () => {
        const card = track.querySelector('.card');
        return card ? card.offsetWidth + 24 : track.clientWidth * 0.8;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
        if (next) next.toggleAttribute('disabled', track.scrollLeft >= max);
      };

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ------------------------------------------------------------------
     Scroll reveal
     ------------------------------------------------------------------ */
  function initReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => {
    Cart.init();
    initMobileNav();
    initGallery();
    initQuantity();
    initCarousels();
    initDrawers();
    initReveal();
  });
})();
